import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Segment, Loader, Message, Form, Button } from 'semantic-ui-react';
import { fetchEmailLogs } from '~/state/ducks/users/operations.js';
import { getToken, getBaseURL } from '~/state/ducks/auth/selectors.js';
import EmailLogData from './EmailLogData.jsx';


const UserTabEmailLogs = ({ userId }) => {
    const dispatch = useDispatch();
    const [emailLogs, setEmailLogs] = useState([]);
    const [loading, setLoading] = useState(true); // State to manage loading state
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading(true);
        setError(null);
        if (userId) {
            dispatch(fetchEmailLogs(userId))
                .then((data) => {
                    console.log('Email logs fetched successfully');
                    setEmailLogs(data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error fetching email logs:', error);
                    setError(error);
                    setLoading(false);
                });
        }

    }, [dispatch, userId]);


    return (
        <Segment>
            <h1>Email Logs</h1>
            { loading && <p className="loading-message">Loading...</p> }
            { error && <p className="error-message">Error fetching email logs: { error.message }</p> }
            { !loading && !error && (!emailLogs || emailLogs.length === 0) && (
                <p className="empty-message">No email logs found for this user.</p>
            ) }
            { !loading && !error && emailLogs && emailLogs.length > 0 && (
                <EmailLogData emailLogs={emailLogs} />
            ) }
        </Segment>
    );
};

UserTabEmailLogs.propTypes = {
    userId: PropTypes.string.isRequired,
};

export { UserTabEmailLogs };

